<template>
  <div>
    <h1 class="greeting">
      Olá, <span class="name">{{ pessoa.nome }}</span>
    </h1>
    <el-card class="user-card">
      <el-row :gutter="20" class="user-info">
        <el-col :xs="30" :sm="14">
          <strong>Nome</strong>
          <div>{{ pessoa.nome }}</div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <strong>CPF/Passaporte</strong>
          <div>
            {{
              pessoa.cpf
                ? formatarDocumento(pessoa.cpf)
                : pessoa.passaporte || "--"
            }}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { formatarDocumento } from "../../utils/layout/mascarasFormat.js";
export default {
  data() {
    return {
      pessoa: JSON.parse(localStorage.getItem("pessoa")) || {
        nome: "",
        cpf: "",
        uf: ""
      }
    };
  },
  methods: { formatarDocumento }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .user-card {
    text-align: center;
    max-width: unset !important;
  }
  .user-card .el-col:first-child {
    margin-bottom: 1rem;
  }
}
h1.greeting {
  color: #295661;
  font-family: Nunito;
  font-size: 18px;
  line-height: normal;
}
.name {
  font-weight: bold;
}
.user-card {
  margin-bottom: 1rem;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 390px;
  font-size: 12px;
}
.user-info {
  display: flex;
  flex-wrap: wrap;
}
.user-info > .el-col strong {
  display: block;
  margin-bottom: 0.25rem;
}
</style>
